
import { Card, CardContent, Box, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText } from '@mui/material';
//import ScienceIcon from '@mui/icons-material/Science';

export default function CardImageMarkers({
  image,
  title,
  subtitle,
  markersTitle,
  markers,
  sx = {},
}) {
  
  
    return (
  
        <Card
            elevation={9}
            sx={{
              width: {xs: 320, sm:360, lg: 400},
              borderRadius: 3,
              overflow: 'hidden',
              boxShadow: '0 6px 24px rgba(15,23,42,0.12)',
              display: 'flex',
              flexDirection: 'column',
              ...sx,
            }}
          >
      {/* Upper half: background image with gradient overlay */}
      <Box
        sx={{
          height: 140,
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
        }}
      >
        {/* soft dark gradient for readability */}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(180deg, rgba(0,0,0,0.24) 0%, rgba(0,0,0,0.6) 100%)',
          }}
        />

        <Box sx={{ position: 'relative', textAlign: 'left', color: 'common.white', px: 2, pb: 1.5 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: 0.6 }}>
            {title}
          </Typography>
          <Typography variant="subtitle2" sx={{fontWeight:'500', mt: 0.5 }}>
            {subtitle}
          </Typography>
        </Box>
      </Box>

      {/* Lower half: content with markers list */}
      <CardContent sx={{ pt: 1, pb:1}}>

        <Typography variant="subtitle" gutterBottom sx={{ fontWeight: 600, mb: 1.25 }}>
          {markersTitle}
        </Typography>

        <Typography variant="subtitle2" sx={{mt:1, fontWeight: 500,  mb: 1.25 }}>
          {markers}
        </Typography>

        
      </CardContent>
    </Card>
  );
}

